import { ReactElement } from 'react';

export type CalendarTipsProps = {
  tips?: string | ReactElement;
  onTips?: () => void;
};

export const CalendarTips = (props: CalendarTipsProps) => {
  if (!props.tips) return null;
  return (
    <div className={`v-calendar-tips`} onClick={props.onTips}>
      {props.tips}
    </div>
  );
};
